import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { LibButtonModule } from '@ui-components/button/button.module';
import { LibContentLoaderModule } from '@ui-components/content-loader';
import { SharedModule } from '@ui-components/shared.module';
import { LibManagementGroupModalModule } from '@ui-components/management-group-modal';
import { LibPreferencesModalModule } from '@ui-components/preferences-modal';
import { LibHeaderComponent } from './header.component';

@NgModule({
  declarations: [
    LibHeaderComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    LibButtonModule,
    LibContentLoaderModule,
    LibPreferencesModalModule,
    LibManagementGroupModalModule,
    MatDialogModule,
    RouterModule
  ],
  exports: [
    LibHeaderComponent
  ]
})
export class LibHeaderModule { }
